import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchAvatars } from './api.ts';

const Ctx = createContext<{
  /** normalized name -> data URL */
  map: Record<string, string>;
  refresh: () => void;
}>({ map: {}, refresh: () => {} });

/** Loads every manager's avatar once so any row can look one up by name. */
export function AvatarProvider({ children }: { children: ReactNode }) {
  const [map, setMap] = useState<Record<string, string>>({});
  const refresh = useCallback(() => {
    fetchAvatars()
      .then(setMap)
      .catch(() => setMap({}));
  }, []);
  useEffect(refresh, [refresh]);
  return <Ctx.Provider value={{ map, refresh }}>{children}</Ctx.Provider>;
}

export function useAvatars() {
  return useContext(Ctx);
}

export function normalizeName(name: string): string {
  return name.trim().toLowerCase();
}
